import { useContext } from 'preact/hooks';
import { ButtonSetPositionContext } from './ButtonSetPositionContext';

/**
 * Utility hook for consuming the ButtonSetPositionContext
 *
 * @returns The value of closest ButtonSetControl provider
 */
function useButtonSetPositionContext() {
  return useContext(ButtonSetPositionContext);
}

export { useButtonSetPositionContext };
